import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
  import type { PropType } from 'vue'
  import eventBus from '@/main'
  import useIcons from '@/composables/useIcons'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomProgressBar',
  props: {
    divisions: {
      type: Number,
      default: 1,
    },
    fillDivisions: {
      type: Array as PropType<boolean[]>,
      default: () => [],
    },
    startAt: {
      type: Number,
      default: -10,
    },
    hasCertLogo: {
      type: Boolean,
      default: true,
    },
  },
  setup(__props) {

const props = __props;

  
  const { logoMarker, certLogo } = useIcons()
  const progressThumbPosition = ref(0)
  const showThumb = ref(true)
  const timerId = ref(0)

  const calculateProgressThumbPosition = () => {
    progressThumbPosition.value = props.startAt
    nextTick(() => {
      const markers = eventBus.$el.querySelectorAll('.marker.fill')
      markers?.forEach((el) => {
        progressThumbPosition.value += (el as HTMLSpanElement).offsetWidth
      })
      progressThumbPosition.value--
    })
  }

  const onResize = () => {
    showThumb.value = false
    if (timerId.value) {
      window.clearTimeout(timerId.value)
    }
    timerId.value = window.setTimeout(() => {
      calculateProgressThumbPosition()
      showThumb.value = true
    }, 200)
  }

  onMounted(() => {
    window.addEventListener('resize', onResize)
    calculateProgressThumbPosition()
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', onResize)
  })

return { __sfc: true,props, logoMarker, certLogo, progressThumbPosition, showThumb, timerId, calculateProgressThumbPosition, onResize, ref, onMounted, onBeforeUnmount, nextTick, eventBus, useIcons }
}

})